import { Provider } from "./provider/Provider";

const SiparislerService = {
  siparisListesi: ({ start, limit, orderBy, listBy }) => {
    return Provider({
      start,
      limit,
      orderBy,
      listBy,
      methodName: "Module/Orders/PanelOrderList"
    });
  },
  siparisDetay: (orderId) => {
    return Provider({
      orderId,
      methodName: "Module/Orders/OrderDetail"
    });
  },
  siparisKargoDetay: (orderId) => {
    return Provider({
      orderId,
      methodName: "Module/Orders/OrderShippingDetail"
    });
  },
  siparisKargoGuncelle: ({ orderId, shippingName, shippingNumber, shippingNote }) => {
    return Provider({
      orderId,
      shippingName,
      shippingNumber,
      shippingNote,
      methodName: "Module/Orders/UpdateShippingDetail"
    });
  },
  orderStatusRelations: () => {
    return Provider({
      methodName: "Module/Orders/OrderStatusRelations"
    });
  },
  updateOrderStatus: ({ orderId, orderStatus }) => {
    return Provider({
      orderId,
      orderStatus,
      methodName: "Module/Orders/UpdateOrderStatus"
    });
  },
  changeOrderAddress: ({ orderId, addressId }) => {
    return Provider({
      orderId,
      addressId,
      methodName: "Module/Orders/ChangeOrderAddress"
    });
  },
  cancelAndRefundList: ({ start, limit, orderBy }) => {
    return Provider({
      start,
      limit,
      orderBy,
      methodName: "Module/Orders/CancelAndRefundList"
    });
  },
  cancelAndRefundListOnHoldCount: () => {
    return Provider({
      methodName: "Module/Orders/CancelAndRefundListOnHoldCount"
    });
  },
  approveRequest: (requestId) => {
    return Provider({
      requestId,
      methodName: "Module/Orders/ApproveRequest"
    });
  },
  resqueRequest: (requestId) => {
    return Provider({
      requestId,
      methodName: "Module/Orders/ResqueRequest"
    });
  },
  holdRequest: (requestId) => {
    return Provider({
      requestId,
      methodName: "Module/Orders/HoldRequest"
    });
  }
};

export default SiparislerService;
